<template>
    <div style="width: 100%">
        <div class="headImg">
            <a href="https://www.gdmusah.com/" target="_blank">
                <img src="../assets/logo.png" alt="广东医科大学附属第二医院">
            </a>
        </div>
        <div class="app-container">
            <div>
                <div class="uploadBox">
                    <div class="certificateUpload">
                        <b style="position: absolute;left: 28px; margin-top: -10px;color: red">*</b>
                        <div v-if="ruleForm1.OneselfPhotograph" class="uploadAvatar" v-loading="photoLoading">
                            <img :src="`${BaseURL}/Common/AttachUrl?channeltype=6&filename=${ruleForm1.OneselfPhotograph}`"
                                 class="avatar">
                            <div class="upload-cover">
                                <i class="el-icon-delete icon-cover" title="删除" @click="photographDel"/>
                            </div>
                        </div>
                        <el-upload v-else class="ImageUploaderBox"
                                   accept='image/gif,image/jpeg,image/jpg,image/png'
                                   action="#" :show-file-list="false" :http-request='uploadOneselfPhotograph'>
                            <img v-if="ruleForm1.OneselfPhotograph"
                                 :src="`${BaseURL}/Common/AttachUrl?channeltype=6&filename=${ruleForm1.OneselfPhotograph}`"
                                 class="ImageUrl">
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            <div v-if="!ruleForm1.OneselfPhotograph" class="IDPhoto">上传证件照</div>
                        </el-upload>
                        <div class="mt10">
                            <div class="d-flex headBox">
                                <div class="headLeft">
                                    您的资料完善度：<b>{{ completionRate }}%</b>
                                </div>
                                <div class="headRight">
                                    <el-link :underline="false" type="primary" @click="handleNotesModal">
                                        预览简历
                                    </el-link>
                                </div>
                            </div>
                            <el-progress :percentage="completionRate"/>
                        </div>
                    </div>
                </div>
                <el-tabs tab-position="right" v-model="tabActiveName" style="pointer-events: none;">
                    <el-tab-pane style="pointer-events: auto;" name="first">
                          <span slot="label">
                              <svg t="1677133878760" class="icon" viewBox="0 0 1024 1024" version="1.1"
                                   xmlns="http://www.w3.org/2000/svg"
                                   p-id="6974" width="15" height="15" style="vertical-align: -1px">
                                <path fill="#555555"
                                      d="M481.614769 0H630.153846l-107.421538 1024H325.257846l107.401846-821.779692C360.093538 258.146462 268.937846 299.716923 157.538462 326.990769V160.630154c54.016-11.480615 111.399385-31.547077 172.169846-60.238769C390.478769 68.844308 441.107692 35.859692 481.614769 0z"
                                      p-id="6975"></path></svg>
                            基本信息
                          </span>
                        <div class="d-flex mt8 mb8 d-align-center">
                            <span class="text-danger">*</span>
                            <span>招聘岗位：</span>
                            <div class="mr15">
                                <el-select v-model="deliveryID" placeholder="请选择岗位类别" filterable
                                           class="w-240" size="small" @change="changePosition">
                                    <el-option v-for="dict in posttitleNav" :key="dict.id"
                                               :label="`${dict.posttitle} ${dict.posttitle == '护理岗位' ? '' : dict.posttitle == '科研岗位' ? '' : dict.posttitle == '党政管理岗位' ? '' : `（${dict.positionname}）`}`"
                                               :value="dict.posttitle"/>
                                </el-select>
                            </div>
                            <div class="mr15">
                                <el-select v-model="positionID" placeholder="请选择科室/部门" filterable style="width: 280px"
                                           size="small" @change="changePositionNav">
                                    <el-option v-for="(item,i) in getDepartNav" :key="item.id"
                                               :label="item.departname"
                                               :value="item.departname"/>
                                </el-select>
                            </div>
                            <div>
                                <el-select v-model="mingeID" placeholder="学历" filterable class="w100"
                                           size="small">
                                    <el-option v-for="(item,i) in pullByDepartNav" :key="item.id"
                                               :label="item.educationname"
                                               :value="item.id"/>
                                </el-select>
                            </div>
                        </div>
                        <el-divider content-position="left">
                            <b style="font-size: 16px">基本信息</b>
                        </el-divider>
                        <div>
                            <div class="formBox">
                                <el-form ref="ruleForm1" :model="ruleForm1" :rules="rules" label-width="160px"
                                         size="small"
                                         label-position="left">
                                    <el-row :gutter="20">
                                        <el-col :md="12">
                                            <el-form-item label="姓名：" prop="UserName">
                                                <b class="asteriskItem">*</b>
                                                <el-input v-model.trim="ruleForm1.UserName" placeholder="请输入姓名"
                                                          clearable/>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :md="12">
                                            <el-form-item label="性别：" prop="Sex">
                                                <b class="asteriskItem">*</b>
                                                <el-select v-model="ruleForm1.Sex" placeholder="请选择性别" filterable
                                                           clearable class="w100">
                                                    <el-option label="男" :value="0"/>
                                                    <el-option label="女" :value="1"/>
                                                </el-select>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :md="12">
                                            <el-form-item label="出生日期：" prop="BirthDate">
                                                <b class="asteriskItem">*</b>
                                                <el-date-picker v-model="ruleForm1.BirthDate" type="date"
                                                                value-format="yyyy-MM-dd"
                                                                placeholder="请选择出生日期" class="w100">
                                                </el-date-picker>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :md="12">
                                            <el-form-item label="民族：" prop="Nation">
                                                <b class="asteriskItem">*</b>
                                                <el-input v-model.trim="ruleForm1.Nation" placeholder="请输入民族"
                                                          clearable/>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :md="12">
                                            <el-form-item label="身高：" prop="Height">
                                                <b class="asteriskItem">*</b>
                                                <el-input v-model.trim="ruleForm1.Height" placeholder="请输入身高（单位cm）"
                                                          clearable/>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :md="12">
                                            <el-form-item label="身份证号：" prop="IDCardNumber">
                                                <b class="asteriskItem">*</b>
                                                <el-input v-model.trim="ruleForm1.IDCardNumber" placeholder="请输入身份证号"
                                                          :maxlength="18" clearable/>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :md="12">
                                            <el-form-item label="政治面貌：" prop="PoliticsStatus">
                                                <b class="asteriskItem">*</b>
                                                <el-select v-model="ruleForm1.PoliticsStatus" placeholder="请选择政治面貌"
                                                           filterable clearable
                                                           class="w100">
                                                    <el-option v-for="dict in politicsNav" :key="dict.dict_code"
                                                               :label="dict.dict_label" :value="dict.dict_label"/>
                                                </el-select>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :md="12">
                                            <el-form-item label="婚姻状况：" prop="MaritalStatus">
                                                <b class="asteriskItem">*</b>
                                                <el-select v-model="ruleForm1.MaritalStatus" placeholder="请选择婚姻状况"
                                                           filterable clearable
                                                           class="w100">
                                                    <el-option label="未婚" :value="0"/>
                                                    <el-option label="已婚" :value="1"/>
                                                    <el-option label="丧偶" :value="2"/>
                                                    <el-option label="离婚" :value="3"/>
                                                </el-select>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :md="12">
                                            <el-form-item label="电子邮箱：" prop="Email">
                                                <b class="asteriskItem">*</b>
                                                <el-input v-model.trim="ruleForm1.Email" placeholder="请输入电子邮箱"
                                                          clearable/>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :md="12">
                                            <el-form-item label="手机号码：" prop="ContactWay">
                                                <b class="asteriskItem">*</b>
                                                <el-input v-model.trim="ruleForm1.ContactWay" :maxlength="11"
                                                          placeholder="请输入手机号码" clearable/>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :md="12">
                                            <el-form-item label="籍贯：" prop="NativePlace">
                                                <b class="asteriskItem">*</b>
                                                <el-input v-model.trim="ruleForm1.NativePlace"
                                                          placeholder="请输入籍贯（例：广东省湛江市霞山区）" clearable/>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :md="12">
                                            <el-form-item label="现户籍地：" prop="PlaceDomicile">
                                                <b class="asteriskItem">*</b>
                                                <el-input v-model.trim="ruleForm1.PlaceDomicile"
                                                          placeholder="请输入现户籍地（例：广东省湛江市霞山区）" clearable/>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :md="12">
                                            <el-form-item label="通讯地址：" prop="MailingAddress">
                                                <b class="asteriskItem">*</b>
                                                <el-input v-model.trim="ruleForm1.MailingAddress"
                                                          placeholder="请输入详细通讯地址（精确到街道、单位或小区）" clearable/>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :md="12">
                                            <el-form-item label="邮政编码：">
                                                <el-input v-model.trim="ruleForm1.ZipCode" placeholder="请输入邮政编码"
                                                          clearable/>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :md="12">
                                            <el-form-item label="最高学历：" prop="HighestEducationID">
                                                <b class="asteriskItem">*</b>
                                                <el-select v-model="ruleForm1.HighestEducationID" placeholder="请选择最高学历"
                                                           filterable clearable
                                                           class="w100" @change="changeHighest">
                                                    <el-option v-for="dict in HighestNav" :key="dict.dict_code"
                                                               :label="dict.dict_label" :value="dict.dict_code"/>
                                                </el-select>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :md="12">
                                            <el-form-item label="学位：" prop="DegreeID">
                                                <b class="asteriskItem">*</b>
                                                <el-select v-model="ruleForm1.DegreeID" placeholder="请选择学位" filterable
                                                           clearable class="w100" @change="changeDegree">
                                                    <el-option v-for="dict in degreeNav" :key="dict.dict_code"
                                                               :label="dict.dict_label" :value="dict.dict_code"/>
                                                </el-select>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :md="12">
                                            <el-form-item label="毕业学校：" prop="GraduateSchool">
                                                <b class="asteriskItem">*</b>
                                                <el-input v-model.trim="ruleForm1.GraduateSchool" placeholder="请输入毕业学校"
                                                          clearable/>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :md="12">
                                            <el-form-item label="毕业时间：" prop="GraduationDate">
                                                <b class="asteriskItem">*</b>
                                                <el-date-picker v-model="ruleForm1.GraduationDate" type="date"
                                                                value-format="yyyy-MM-dd"
                                                                placeholder="请选择毕业时间"
                                                                class="w100">
                                                </el-date-picker>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :md="12">
                                            <el-form-item label="学习形式：" prop="LearningStyleID">
                                                <b class="asteriskItem">*</b>
                                                <el-select v-model="ruleForm1.LearningStyleID" placeholder="请选择学习形式"
                                                           filterable clearable
                                                           class="w100" @change="changeLearning">
                                                    <el-option v-for="dict in learningNav" :key="dict.dict_code"
                                                               :label="dict.dict_label" :value="dict.dict_code"/>
                                                </el-select>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :md="12">
                                            <el-form-item label="专业：" prop="Major">
                                                <b class="asteriskItem">*</b>
                                                <el-input v-model.trim="ruleForm1.Major" placeholder="请输入所学专业"
                                                          clearable/>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :md="12">
                                            <el-form-item label="英语水平等级：" prop="EnglishLevelID">
                                                <b class="asteriskItem">*</b>
                                                <el-select v-model="ruleForm1.EnglishLevelID" placeholder="请选择英语水平等级"
                                                           filterable clearable
                                                           class="w100" @change="changeEnglish">
                                                    <el-option v-for="dict in englishNav" :key="dict.dict_code"
                                                               :label="dict.dict_label" :value="dict.dict_code"/>
                                                </el-select>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :md="12">
                                            <el-form-item label="计算机水平等级：" prop="ComputerLevel">
                                                <b class="asteriskItem">*</b>
                                                <el-input v-model.trim="ruleForm1.ComputerLevel"
                                                          placeholder="请输入计算机水平等级"
                                                          clearable/>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :md="12">
                                            <el-form-item label="参加工作时间：">
                                                <el-date-picker v-model="ruleForm1.worktime" type="date"
                                                                value-format="yyyy-MM-dd"
                                                                placeholder="请选择参加工作时间（只填写正式工作经历，由单位缴纳社保的工作经历）"
                                                                class="w100">
                                                </el-date-picker>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :md="12">
                                            <el-form-item label="工作单位：">
                                                <el-input v-model.trim="ruleForm1.LastCompany"
                                                          placeholder="请输入工作单位（只填写正式工作经历，由单位缴纳社保的工作经历）"
                                                          clearable/>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :md="12">
                                            <el-form-item label="单位性质：">
                                                <el-select v-model="ruleForm1.NatureUnitID" placeholder="请选择单位性质"
                                                           filterable clearable
                                                           class="w100"
                                                           @change="changeNatureUnit">
                                                    <el-option v-for="dict in NatureUnitNav" :key="dict.dict_code"
                                                               :label="dict.dict_label" :value="dict.dict_code"/>
                                                </el-select>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :md="12">
                                            <el-form-item label="最高专业技术资格：" prop="ProfessionalSkill">
                                                <b class="asteriskItem">*</b>
                                                <el-input v-model.trim="ruleForm1.ProfessionalSkill"
                                                          placeholder="请输入最高专业技术资格（若无，请填无）" clearable/>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :md="12">
                                            <el-form-item label="职称：">
                                                <el-input v-model.trim="ruleForm1.Post" placeholder="请输入职称" clearable/>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :md="12">
                                            <el-form-item label="执业资格：">
                                                <el-input v-model.trim="ruleForm1.PracticeCertificate"
                                                          placeholder="请输入执业资格"
                                                          clearable/>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-form>
                            </div>
                            <div class="text-center mt20">
                                <el-button type="primary" @click="submitForm(1)" size="small" icon="el-icon-right">
                                    下一步
                                </el-button>
                            </div>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane style="pointer-events: auto;" name="second">
          <span slot="label">
            <svg t="1677134028033" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
                 p-id="7254" width="15" height="15" style="vertical-align: -1px"><path
                    d="M546.461538 0c93.144615 0 170.121846 28.140308 230.872616 84.401231C836.745846 140.662154 866.461538 212.401231 866.461538 302.414769c0 87.217231-51.081846 165.986462-113.191384 237.725539-37.809231 42.180923-105.334154 95.645538-199.837539 161.752615-98.579692 67.505231-157.991385 126.582154-179.593846 177.230769H849.132308L829.971692 1024H157.538462c0-99.564308 48.364308-185.895385 109.23323-260.312615l5.789539-6.931693c35.111385-42.200615 109.371077-104.093538 221.459692-184.280615l15.753846-11.579077c53.76-39.975385 91.904-73.964308 116.578462-100.942769 41.846154-49.230769 82.116923-102.675692 82.116923-158.936616 0-54.862769-14.848-95.645538-41.846154-122.387692-28.356923-26.722462-70.222769-39.384615-125.577846-39.384615-57.206154 0-100.647385 19.574154-130.323692 58.702769l-3.347693 4.608c-29.715692 39.384615-45.922462 99.859692-48.620307 178.628923H200.782769C202.082462 272.068923 231.325538 184.123077 289.732923 116.046769l5.572923-6.340923C358.754462 36.568615 442.486154 0 546.441846 0z"
                    p-id="7255" fill="#555555"></path></svg>
            学习经历
          </span>
                        <!-- 学习经历 -->
                        <div class="mt35">
                            <el-divider content-position="left">
                                <b style="font-size: 16px">学习经历 <span class="text-danger">（请从中学开始填写）</span> </b>
                            </el-divider>
                            <div class="text-right mb20">
                                <el-button type="primary" size="small" @click="addLineEducational">增加行</el-button>
                            </div>
                            <el-table :data="StudyList" class="w100" border height="510"
                                      :header-cell-style='{background:"#F8F8F8",fontWeight:"normal",fontSize:"14px",color: "#333333"}'>
                                <el-table-column type="index" label="序号" align="center" width="55"/>
                                <el-table-column prop="StudyStartDate" label="学习开始时间" align="center">
                                    <template slot-scope="scope">
                                        <el-date-picker
                                                v-model="scope.row.StudyStartDate"
                                                size="small"
                                                class="w100"
                                                type="date"
                                                value-format="yyyy-MM-dd"
                                                placeholder="请选择开始时间">
                                        </el-date-picker>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="StudyEndDate" label="学习结束时间" align="center">
                                    <template slot-scope="scope">
                                        <el-date-picker
                                                v-model="scope.row.StudyEndDate"
                                                class="w100"
                                                size="small"
                                                type="date"
                                                value-format="yyyy-MM-dd"
                                                placeholder="请选择结束时间">
                                        </el-date-picker>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="EducationID" label="学历" align="center">
                                    <template slot-scope="scope">
                                        <el-select v-model="scope.row.EducationID" placeholder="请选择学历" filterable
                                                   clearable class="w100" size="small">
                                            <el-option v-for="dict in EducationNav" :key="dict.dict_code"
                                                       :label="dict.dict_label" :value="`${dict.dict_code}`"/>
                                        </el-select>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="GraduationSchool" label="毕业院校" align="center">
                                    <template slot-scope="scope">
                                        <el-input v-model.trim="scope.row.GraduationSchool" placeholder="请输入毕业院校"
                                                  size="small"/>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="EducationalSystem" label="学制" align="center">
                                    <template slot-scope="scope">
                                        <el-input v-model.trim="scope.row.EducationalSystem" placeholder="请输入学制"
                                                  size="small"/>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="Major" label="所学专业" align="center">
                                    <template slot-scope="scope">
                                        <el-input v-model.trim="scope.row.Major" placeholder="请输入所学专业" clearable
                                                  size="small"/>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="LearningStyleID" label="学习形式" align="center">
                                    <template slot-scope="scope">
                                        <el-select v-model="scope.row.LearningStyleID" placeholder="请选择学习形式" filterable
                                                   clearable
                                                   class="w100"
                                                   size="small">
                                            <el-option v-for="dict in learningNav" :key="dict.dict_code"
                                                       :label="dict.dict_label" :value="dict.dict_code"/>
                                        </el-select>
                                    </template>
                                </el-table-column>
                                <el-table-column label="操作" align="center" min-width="30">
                                    <template slot-scope="scope">
                                        <el-button
                                                size="mini"
                                                type="text"
                                                v-if="!scope.row.editing"
                                                icon="el-icon-delete"
                                                @click="handleDelete(scope.$index, scope.row)"
                                        >删除
                                        </el-button>
                                    </template>
                                </el-table-column>
                                <el-empty slot="empty" description="暂无数据"/>
                            </el-table>
                        </div>
                        <div class="text-center mt20">
                            <el-button type="primary" @click="handleTabActiveName('first')" size="small"
                                       icon="el-icon-upload2" plain class="mr20">
                                上一步
                            </el-button>
                            <el-button type="primary" @click="submitForm(2)" size="small" icon="el-icon-right">
                                下一步
                            </el-button>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane style="pointer-events: auto;" name="third">
          <span slot="label">
        <svg t="1677134213020" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
             p-id="8373" width="18" height="18" style="vertical-align: -3px;margin-right: -2px;"><path
                d="M224.888933 725.854623l141.887544-33.385365c11.128455 97.373725 62.597687 147.452283 154.407696 150.23363 114.066919 2.78237 169.709193-48.686862 166.926824-154.407696-8.346085-83.4629-63.98836-126.586047-166.926824-129.368416L416.854013 558.926776 416.854013 437.906491l70.943772 0c105.71981 0 161.363108-44.51382 166.926824-133.541459-2.78237-72.334445-44.51382-109.893876-125.195374-112.675222-80.681554 5.564739-129.368416 51.469232-146.060587 137.714502l-141.887544-33.385365c38.949081-150.23363 133.541459-226.742141 283.775088-229.52451 178.055279 2.78237 269.865287 83.463923 275.429003 242.043638 0 83.4629-45.904493 143.279241-137.714502 179.445952 111.284549 44.51382 168.317497 114.066919 171.099866 208.658274-11.128455 166.926824-112.675222 254.56379-304.641325 262.909875C357.038696 956.770829 255.491928 878.871645 224.888933 725.854623z"
                p-id="8374" fill="#555555"></path></svg>
            工作经历
          </span>
                        <!-- 工作经历 -->
                        <div class="mt35">
                            <el-divider content-position="left">
                                <b style="font-size: 16px">工作经历</b>
                            </el-divider>
                            <div class="text-right mb20">
                                <el-button type="primary" size="small" @click="addLineWork">增加行</el-button>
                            </div>
                            <el-table :data="WorkList" class="w100" border height="510"
                                      :header-cell-style='{background:"#F8F8F8",fontWeight:"normal",fontSize:"14px",color: "#333333"}'>
                                <el-table-column type="index" label="序号" align="center" width="55"/>
                                <el-table-column prop="WorkStartDate" label="工作开始时间" align="center">
                                    <template slot-scope="scope">
                                        <el-date-picker
                                                size="small"
                                                v-model="scope.row.WorkStartDate"
                                                class="w100"
                                                type="date"
                                                value-format="yyyy-MM-dd"
                                                placeholder="请选择开始时间">
                                        </el-date-picker>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="WorkEndDate" label="工作结束时间" align="center">
                                    <template slot-scope="scope">
                                        <el-date-picker
                                                size="small"
                                                v-model="scope.row.WorkEndDate"
                                                class="w100"
                                                type="date"
                                                value-format="yyyy-MM-dd"
                                                placeholder="请选择结束时间">
                                        </el-date-picker>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="WorkUnit" label="工作单位" align="center">
                                    <template slot-scope="scope">
                                        <el-input v-model.trim="scope.row.WorkUnit" placeholder="请输入工作单位" clearable
                                                  class="w100" size="small"/>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="ProfessionalTitle" label="职称" align="center">
                                    <template slot-scope="scope">
                                        <el-input v-model.trim="scope.row.ProfessionalTitle" placeholder="请输入职称"
                                                  clearable
                                                  class="w100"
                                                  size="small"/>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="Post" label="职务" align="center">
                                    <template slot-scope="scope">
                                        <el-input v-model.trim="scope.row.Post" placeholder="请输入职务" clearable
                                                  class="w100"
                                                  size="small"/>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="WorkName" label="主要从事工作" align="center">
                                    <template slot-scope="scope">
                                        <el-input v-model.trim="scope.row.WorkName" placeholder="请输入主要从事工作" clearable
                                                  class="w100" size="small"/>
                                    </template>
                                </el-table-column>
                                <el-table-column label="操作" align="center" min-width="40">
                                    <template slot-scope="scope">
                                        <el-button
                                                size="mini"
                                                type="text"
                                                v-if="!scope.row.editing"
                                                icon="el-icon-delete"
                                                @click="handleDelLineWork(scope.$index, scope.row)"
                                        >删除
                                        </el-button>
                                    </template>
                                </el-table-column>
                                <el-empty slot="empty" description="暂无数据"/>
                            </el-table>
                        </div>
                        <div class="text-center mt20">
                            <el-button type="primary" @click="handleTabActiveName('second')" size="small"
                                       icon="el-icon-upload2" plain class="mr20">
                                上一步
                            </el-button>
                            <el-button type="primary" @click="submitForm(3)" size="small" icon="el-icon-right">
                                下一步
                            </el-button>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane style="pointer-events: auto;" name="fourth">
          <span slot="label">
            <svg t="1677134230607" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
                 p-id="8513" width="18" height="18" style="vertical-align: -4px"><path
                    d="M831.246975 620.50218l0 125.195374c-25.039279 0-63.98836 0-116.849288 0 0 86.24527 0 153.015999 0 200.312188l-133.541459 0c0-47.296189 0-114.066919 0-200.312188-150.23363 0-279.602046 0-388.105249 0l0-95.983051L610.069573 65.471131l104.329137 0c0 164.144454 0 349.155145 0 555.032072C767.258615 620.50218 806.208718 620.50218 831.246975 620.50218zM580.857251 620.50218 580.857251 299.168684 355.505783 620.50218 580.857251 620.50218z"
                    p-id="8514" fill="#555555"></path></svg>
            家庭成员
          </span>
                        <!--  家庭成员 -->
                        <div class="mt35">
                            <el-divider content-position="left">
                                <b style="font-size: 16px">家庭成员</b>
                            </el-divider>
                            <div class="text-right mb20">
                                <el-button type="primary" size="small" @click="addLineFamily">增加行</el-button>
                            </div>
                            <el-table :data="MemberFamilyList" class="w100" border height="510"
                                      :header-cell-style='{background:"#F8F8F8",fontWeight:"normal",fontSize:"14px",color: "#333333"}'>
                                <el-table-column type="index" label="序号" align="center" width="55"/>
                                <el-table-column prop="UserName" label="姓名" align="center">
                                    <template slot-scope="scope">
                                        <el-input v-model.trim="scope.row.UserName" placeholder="请输入姓名" size="small"
                                                  clearable/>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="Relationship" label="与本人关系" align="center">
                                    <template slot-scope="scope">
                                        <el-input v-model.trim="scope.row.Relationship" placeholder="请输入与本人关系"
                                                  size="small"
                                                  clearable/>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="WorkUnit" label="工作单位" align="center">
                                    <template slot-scope="scope">
                                        <el-input v-model.trim="scope.row.WorkUnit" placeholder="请输入工作单位" size="small"
                                                  clearable/>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="Post" label="职务" align="center">
                                    <template slot-scope="scope">
                                        <el-input v-model.trim="scope.row.Post" placeholder="请输入职务" size="small"
                                                  clearable/>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="PlaceDomicile" label="户籍所在地" align="center">
                                    <template slot-scope="scope">
                                        <el-input v-model.trim="scope.row.PlaceDomicile" placeholder="请输入户籍所在地"
                                                  size="small"
                                                  clearable/>
                                    </template>
                                </el-table-column>
                                <el-table-column label="操作" align="center" min-width="40">
                                    <template slot-scope="scope">
                                        <el-button
                                                size="mini"
                                                type="text"
                                                v-if="!scope.row.editing"
                                                icon="el-icon-delete"
                                                @click="handleDelLineFamily(scope.$index, scope.row)"
                                        >删除
                                        </el-button>
                                    </template>
                                </el-table-column>
                                <el-empty slot="empty" description="暂无数据"/>
                            </el-table>
                        </div>
                        <div class="text-center mt20">
                            <el-button type="primary" @click="handleTabActiveName('third')" size="small"
                                       icon="el-icon-upload2" plain class="mr20">
                                上一步
                            </el-button>
                            <el-button type="primary" @click="submitForm(4)" size="small" icon="el-icon-right">
                                下一步
                            </el-button>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane style="pointer-events: auto;" name="fifth">
          <span slot="label">
            <svg t="1677134261893" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
                 p-id="8653" width="18" height="18" style="vertical-align: -3px"><path
                    d="M299.908534 87.355557l479.914234 0 0 125.195374L416.756799 212.55093l-20.866237 191.966103c33.385365-27.821649 80.681554-43.123147 141.887544-45.904493 180.837648 11.128455 276.8207 108.50218 287.949154 292.122197-5.564739 200.312188-105.71981 303.250652-300.468283 308.814368-172.490539 0-275.429003-79.289857-308.814368-237.870596l137.714502-29.212322c16.692171 100.156094 70.943772 150.23363 162.753781 150.23363 108.50218-2.78237 164.144454-63.98836 166.926824-183.620018-2.78237-111.284549-57.032948-168.317497-162.753781-171.099866-89.027639 0-146.060587 30.602995-171.099866 91.810009l-104.329137-20.866237L299.908534 87.355557z"
                    p-id="8654" fill="#555555"></path></svg>
            其他
          </span>
                        <el-divider content-position="left">
                            <b style="font-size: 16px">其他</b>
                        </el-divider>
                        <el-form :model="form2" label-width="145px" size="small" label-position="top">
                            <el-form-item label="奖惩情况：">
                                <el-input type="textarea" :rows="12" placeholder="请输入内容"
                                          v-model="form2.HonorCertificates" maxlength="2000" show-word-limit></el-input>
                            </el-form-item>
                            <el-form-item label="个人特长及突出业绩：">
                                <el-input type="textarea" :rows="12" placeholder="请输入内容"
                                          v-model="form2.Characteristic" maxlength="2000" show-word-limit></el-input>
                            </el-form-item>
                            <el-form-item>
              <span slot="label">
                备注：<span class="text-danger">（请填写符合岗位条件的补充说明事项）</span>
              </span>
                                <el-input type="textarea" :rows="12" placeholder="请输入内容"
                                          v-model="form2.Remark" maxlength="2000" show-word-limit></el-input>
                            </el-form-item>
                        </el-form>
                        <div class="text-center mt20">
                            <el-button type="primary" @click="handleTabActiveName('fourth')" size="small"
                                       icon="el-icon-right">
                                上一步
                            </el-button>
                            <el-button type="primary" @click="submitForm(5)" size="small" icon="el-icon-right">
                                下一步
                            </el-button>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane style="pointer-events: auto;" name="sixth">
                      <span slot="label">
                        <svg t="1677134281260" class="icon" viewBox="0 0 1024 1024" version="1.1"
                             xmlns="http://www.w3.org/2000/svg"
                             p-id="8793" width="18" height="18" style="vertical-align: -3px"><path
                                d="M804.14778 267.919982l-133.541459 37.558407c-22.25691-80.681554-68.161403-119.630634-137.714502-116.848265-125.195374-2.78237-186.401364 86.24527-183.620018 267.082918 44.51382-61.20599 108.50218-91.810009 191.966103-91.810009 175.272909 8.346085 267.082918 105.71981 275.429003 292.122197-11.128455 189.183733-107.111506 289.339828-287.949154 300.468283-217.004359 5.564739-324.115865-134.932132-321.334519-421.490613 0-314.379107 109.893876-471.568149 329.680605-471.568149C673.38869 68.99949 762.41633 137.160893 804.14778 267.919982zM528.718777 843.818291c94.592378-2.78237 143.279241-63.98836 146.060587-183.620018-2.78237-114.066919-51.469232-172.491563-146.060587-175.272909-116.849288 2.78237-176.664605 55.642275-179.445952 158.580738C352.054171 774.265192 411.870512 841.035922 528.718777 843.818291z"
                                p-id="8794" fill="#555555"></path></svg>
                        附件
                      </span>
                        <el-divider content-position="left">
                            <b style="font-size: 16px">附件</b>
                        </el-divider>
                        <el-form ref="form" :model="form3" :rules="rules" label-width="145px" size="small"
                                 label-position="top">
                            <el-form-item>
              <span slot="label">
                <b style="position: absolute;margin-top: -10px;color: red;">*</b>
                <span style="font-weight: bold;margin-left: 6px;">个人简历</span>
              </span>
                                <el-upload ref="upload" style="display: inline-block"
                                           action="#"
                                           accept='.jpeg,.jpg,.png,.pdf'
                                           :file-list="fileResumeList"
                                           :http-request="uploadFile"
                                           :on-remove="handleFileRemove"
                                           :auto-upload="true"
                                           :limit="5"
                                           :before-upload="checkFileType">
                                    <el-button slot="trigger" size="small" type="primary" plain>
                                        点击上传简历
                                    </el-button>
                                </el-upload>
                            </el-form-item>
                            <el-form-item required>
              <span slot="label">
                <b style="position: absolute;margin-top: -10px;color: red">*</b>
                <span style="font-weight: bold;margin-left: 6px;">身份证</span>
              </span>
                                <div class="mb20">
                                    <el-upload action="#" accept='.jpeg,.jpg,.png' :before-upload="checkFileTypeImage"
                                               :http-request='uploadJust' :show-file-list='false'>
                                        <el-button slot="trigger" size="small" type="primary" plain>
                                            点击上传身份证正面
                                        </el-button>
                                    </el-upload>
                                    <div class="upload-list" v-show="fileNameIDCardFront">
                                        <div class="upload_list_item mt10">
                                            <div class="upload_list_item-name">
                                                <i class="el-icon-document iconPrefix"/>
                                                {{ fileNameIDCardFront }}
                                                <i class="el-icon-upload-success el-icon-circle-check iconSuffix"></i>
                                                <i class="el-icon-close iconSuffix" @click="iconSuffixDel()"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <el-upload action="#" accept='.jpeg,.jpg,.png' :before-upload="checkFileTypeImage"
                                               :http-request='uploadBack' :show-file-list='false'>
                                        <el-button slot="trigger" size="small" type="primary" plain>
                                            点击上传身份证反面
                                        </el-button>
                                    </el-upload>
                                    <div class="upload-list" v-show="fileNameIDCardRear">
                                        <div class="upload_list_item mt10">
                                            <div class="upload_list_item-name">
                                                <i class="el-icon-document iconPrefix"/>
                                                {{ fileNameIDCardRear }}
                                                <i class="el-icon-upload-success el-icon-circle-check iconSuffix"></i>
                                                <i class="el-icon-close iconSuffix" @click="iconPrefixDel()"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </el-form-item>
                            <el-form-item>
              <span slot="label">
                  <span style="font-weight: bold">
                      各层次毕业证、学位证
                      <span class="text-danger">（必须提供）</span>
                  </span>
                </span>
                                <div class="mb20">
                                    <el-upload ref="upload" style="display: inline-block"
                                               action="#"
                                               accept='.jpeg,.jpg,.png'
                                               :file-list="DiplomaList"
                                               :http-request="diplomaProveUploadFile"
                                               :on-remove="diplomaProveUploadFileRemove"
                                               :before-upload="checkFileTypeImage"
                                               :auto-upload="true"
                                               :limit="5">
                                        <el-button slot="trigger" size="small" type="primary" plain>
                                            点击上传毕业证
                                        </el-button>
                                    </el-upload>
                                </div>
                                <div>
                                    <el-upload ref="upload" style="display: inline-block"
                                               action="#"
                                               accept='.jpeg,.jpg,.png'
                                               :file-list="DegreeCertificate"
                                               :http-request="educationDegreeProveUploadFile"
                                               :on-remove="fileDegreFileRemove"
                                               :before-upload="checkFileTypeImage"
                                               :auto-upload="true"
                                               :limit="5">
                                        <el-button slot="trigger" size="small" type="primary" plain>
                                            点击上传学位证
                                        </el-button>
                                    </el-upload>
                                </div>
                            </el-form-item>
                            <el-form-item>
              <span slot="label">
                <span style="font-weight: bold">
                    学信网生成的各层次学历、学位认证报告<span class="text-danger">（必须提供）</span>
                </span>
              </span>
                                <div class="mb20">
                                    <el-upload ref="upload" style="display: inline-block"
                                               action="#"
                                               accept='.jpeg,.jpg,.png,.pdf'
                                               :file-list="DiplomaAuthentica"
                                               :before-upload="checkFileType"
                                               :http-request="DiplomaAuthenticaUploadFile"
                                               :on-remove="DiplomaAuthenticaFileRemove"
                                               :auto-upload="true"
                                               :limit="5">
                                        <el-button slot="trigger" size="small" type="primary" plain>
                                            点击上传学历认证报告
                                        </el-button>
                                    </el-upload>
                                </div>
                                <div>
                                    <el-upload ref="upload" style="display: inline-block"
                                               action="#"
                                               accept='.jpeg,.jpg,.png,.pdf'
                                               :file-list="DegreeCertificateAuthentica"
                                               :http-request="DegreeCertificationUploadFile"
                                               :on-remove="DegreeCertificationFileRemove"
                                               :before-upload="checkFileType"
                                               :auto-upload="true"
                                               :limit="5">
                                        <el-button slot="trigger" size="small" type="primary" plain>
                                            点击上传学位认证报告
                                        </el-button>
                                    </el-upload>
                                </div>
                            </el-form-item>
                            <el-form-item>
                                <span style="font-weight: bold">
                                    应届毕业生证明材料<span class="text-danger">（应届生必须提供）</span>
                                </span>
                                <div class="mb20">
                                    <el-upload ref="upload" style="display: inline-block"
                                               action="#"
                                               :file-list="StudentCertification"
                                               :http-request="studentStatusProveUploadFile"
                                               :on-remove="studentStatusProveFileRemove"
                                               :auto-upload="true"
                                               :limit="5">
                                        <el-button slot="trigger" size="small" type="primary" plain>
                                            点击上传学籍认证报告
                                        </el-button>
                                    </el-upload>
                                </div>
                                <div>
                                    <el-upload ref="upload" style="display: inline-block"
                                               action="#"
                                               :file-list="GetJobRecommend"
                                               :http-request="otherRelevantProveUploadFile"
                                               :on-remove="otherRelevantProveFileRemove"
                                               :auto-upload="true"
                                               :limit="5">
                                        <el-button slot="trigger" size="small" type="primary" plain>
                                            点击上传就业推荐表、学校成绩单、学生证等其他相关证明材料
                                        </el-button>
                                    </el-upload>
                                </div>
                            </el-form-item>
                            <el-form-item>
              <span slot="label">
                <span style="font-weight: bold">
                    工作证明<span class="text-danger">（有工作经历者必须提供工作证明）</span>
                </span>
              </span>
                                <el-upload ref="upload" style="display: inline-block"
                                           action="#"
                                           :file-list="WorkProve"
                                           :http-request="WorkProveUploadFile"
                                           :on-remove="WorkProveFileRemove"
                                           :auto-upload="true"
                                           :limit="5">
                                    <el-button slot="trigger" size="small" type="primary" plain>
                                        点击上传工作证明
                                    </el-button>
                                </el-upload>
                            </el-form-item>
                            <el-form-item>
              <span slot="label">
                <span style="font-weight: bold">各级专业技术资格证书</span>
              </span>
                                <el-upload ref="upload" style="display: inline-block"
                                           action="#"
                                           :file-list="QualificationCertificate"
                                           :http-request="QualificationCertificateUploadFile"
                                           :on-remove="QualificationCertificateFileRemove"
                                           :auto-upload="true"
                                           :limit="5">
                                    <el-button slot="trigger" size="small" type="primary" plain>
                                        点击上传各级专业技术资格证书
                                    </el-button>
                                </el-upload>
                            </el-form-item>
                            <el-form-item>
              <span slot="label">
                <span style="font-weight: bold">获奖证书及其他有关证书</span>
              </span>
                                <el-upload ref="upload" style="display: inline-block"
                                           action="#"
                                           :file-list="RestsCertificate"
                                           :http-request="RestsCertificateUploadFile"
                                           :on-remove="fileRestscertificateListRemove"
                                           :auto-upload="true"
                                           :limit="5">
                                    <el-button slot="trigger" size="small" type="primary" plain>
                                        点击上传获奖证书及其他有关证书
                                    </el-button>
                                </el-upload>
                            </el-form-item>
                        </el-form>
                        <div class="text-center mt20">
                            <el-button type="primary" @click="handleTabActiveName('fifth')" size="small"
                                       icon="el-icon-upload2" plain class="mr20">
                                上一步
                            </el-button>
                            <el-button type="primary" @click="submitForm(6)" size="small">
                                <i class="el-icon-document mr4"/>预览简历
                            </el-button>
                            <!--<el-button type="primary" @click="submitForm(6)" size="small" :disabled="count != 0">
                                <i class="el-icon-document mr4"/>提交
                            </el-button>-->
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </div>
            <!-- 提交 -->
            <notesModal ref="socialModalRef" :show.sync="notesModalShow" :previewData="previewData"/>
            <seeModal ref="seeModalRef" :show.sync="seeModalShow" :previewData="previewData"/>
        </div>
        <div class="footer-bottom">
            <span class="mr25">咨询热线：0759-2372012、0759-2372603</span> <span>技术支持热线：0755-82511399</span>
        </div>
    </div>
</template>

<script>
    import notesModal from './modules/notesModal'
    import seeModal from './modules/seeModal'
    import {verifyMailbox, validateSfz, verifyPhone} from "../utils/index";
    import {isMobile} from '@/utils/index'

    export default {
        components: {
            notesModal,
            seeModal
        },
        data() {
            const checkPhone = (rule, value, callback) => {
                if (!value) {
                    callback(new Error('请输入联系方式'))
                } else if (!verifyPhone(value)) {
                    callback(new Error('您输入的手机号码格式不正确'))
                } else {
                    callback()
                }
            }

            // 邮箱
            const emailValue = (rule, value, callback) => {
                if (!value) {
                    callback(new Error('请输入邮箱'))
                } else if (!verifyMailbox(value)) {
                    callback(new Error('您输入的邮箱格式不正确'))
                } else {
                    callback()
                }
            }

            return {
                completionRate: 0,
                photoLoading: false,
                fileNameIDCardFront: '',
                fileNameIDCardRear: '',  // 身份证反面文件名
                notesModalShow: false,
                seeModalShow: false,
                tabActiveName: 'first',
                disabled: false,
                previewData: {},   // 预览数据
                BaseURL: 'http://zjeyapi2.ypaiban.com/api',
                posttitleNav: [],  // 获取岗位下拉
                getDepartNav: [],   // 获取部门下拉
                pullByDepartNav: [],  // 学历
                fileList: [],
                HighestNav: [],   // 最高学历
                learningNav: [],  // 学习形式
                degreeNav: [],   // 学位
                politicsNav: [],   // 政治面貌
                englishNav: [],   // 英语水平等级
                NatureUnitNav: [],   // 单位性质
                EducationNav: [],   // 最高学历
                deliveryID: '',    // 岗位投递选择
                positionID: '',   // 科室
                mingeID: '',   // 学历
                mingeName: '',  // 学历名
                // 家庭成员
                MemberFamilyList: [],
                // 学习经历
                StudyList: [],
                // 工作经历
                WorkList: [],
                ruleForm1: {
                    PlanID: '',
                    UserName: '',   // 姓名
                    OneselfPhotograph: '',  // 个人证件
                    BirthDate: '',  // 出生年月日
                    Sex: '',   // 性别 （0 男 1 女）
                    Nation: '',   // 民族
                    NativePlace: '',   // 籍贯
                    PoliticsStatus: '',  // 政治面貌
                    PlaceDomicile: '',    // 现户籍地
                    MaritalStatus: '',   // 婚姻状况 0未婚 1 已婚 2离异 3 丧偶
                    IDCardNumber: '',   // 身份证号码
                    ContactWay: '',   // 联系方式
                    Email: '',  // 电子邮箱
                    MailingAddress: '',  // 通讯地址
                    ZipCode: '',    // 邮编
                    HighestEducationID: '',   // 最高学历ID
                    HighestEducation: '',    // 最高学历
                    GraduationDate: '', // 毕业时间
                    GraduateSchool: '',  // 毕业学校
                    Major: '',   // 专业
                    Post: '',  // 职称
                    ProfessionalSkill: '',  // 专业技术资格
                    Height: '',   // 身高
                    DegreeID: '', // 学位ID
                    Degree: '', // 学位
                    EnglishLevelID: '', // 英语水平ID
                    EnglishLevel: '',  // 英语水平等级
                    ComputerLevel: '', // 计算机水平等级
                    LastCompany: '',   // 工作单位（实习/规培）
                    NatureUnit: '',  // 单位性质(0=企业;1=事业单位、2=国家行政机关;3=政府)
                    NatureUnitID: '',  // 单位性质ID
                    LearningStyleID: '',   // 学习形式ID
                    LearningStyle: '',   // 学习形式
                    PracticeCertificate: '',  // 执业资格
                    worktime: '',  // 参加工作时间
                },

                form2: {
                    HonorCertificates: '',   // 奖惩情况
                    Characteristic: '',    // 个人特长及突出业绩
                    Remark: '',    // 备注
                },

                DegreeCertificate: [],   // 学位证明
                DiplomaList: [],     // 毕业证
                DiplomaAuthentica: [],  // 毕业认证
                DegreeCertificateAuthentica: [],    // 学位证明
                WorkProve: [],   // 工作证明
                QualificationCertificate: [],  // 资格证书
                RestsCertificate: [],   // 获奖证书及其他有关证书
                StudentCertification: [],   // 学籍认证报告
                GetJobRecommend: [],  //  就业推荐表、学校成绩单、学生证等其他相关证明材料
                fileResumeList: [],   // 个人简历
                form3: {
                    IDCardRear: '',  // 身份证反面
                    IDCardFront: '',  // 身份证正面
                    ReportCard: '',  // 学校成绩单
                    StudentCard: '',   // 学生证
                },

                rules: {
                    UserName: [{required: true, trigger: "blur", message: "请输入姓名"}],
                    Sex: [{required: true, trigger: "change", message: "请输入性别"}],
                    BirthDate: [{required: true, trigger: "change", message: "请选择出生日期"}],
                    ContactWay: [{required: true, validator: checkPhone, trigger: 'blur'}],
                    Email: [{required: true, validator: emailValue, trigger: "blur"}],
                    HighestEducationID: [{required: true, trigger: "change", message: "请选择最高学历"}],
                    GraduateSchool: [{required: true, trigger: "blur", message: "请输入毕业学校"}],
                    LearningStyleID: [{required: true, trigger: "change", message: "请选择学习形式"}],
                    IDCardNumber: [{required: true, validator: validateSfz, trigger: 'blur'}],
                    DegreeID: [{required: true, trigger: "change", message: "请选择学位"}],
                    NativePlace: [{required: true, trigger: "blur", message: "请输入籍贯"}],
                    GraduationDate: [{required: true, trigger: "change", message: "请选择毕业时间"}],
                    Major: [{required: true, trigger: "blur", message: "请输入所学专业"}],
                    PoliticsStatus: [{required: true, trigger: "change", message: "请选择政治面貌"}],
                    MaritalStatus: [{required: true, trigger: "change", message: "请选择婚姻状况"}],
                    PlaceDomicile: [{required: true, trigger: "blur", message: "请输入现户籍地（例：广东省湛江市霞山区）"}],
                    Nation: [{required: true, trigger: "blur", message: "请输入民族"}],
                    EnglishLevelID: [{required: true, trigger: "change", message: "请选择英语水平等级"}],
                    ComputerLevel: [{required: true, trigger: "blur", message: "请输入计算机水平等级"}],
                    Height: [{required: true, trigger: "blur", message: "请输入身高（单位cm）"}],
                    ProfessionalSkill: [{required: true, trigger: "blur", message: "请输入最高专业技术资格"}],
                    MailingAddress: [{required: true, trigger: "blur", message: "请输入详细通讯地址（精确到街道、单位或小区）"}],
                },

                dropTitle: '',
                droptionname: '',
            }
        },
        created() {
            this.getHighestNav()   // 最高学历
            this.getLearningNav()   // 学习形式
            this.getDegreeNav()   // 学位
            this.getPoliticsNav()   // 政治面貌
            this.getEnglishNav()  // 英语水平等级
            this.getNatureUnitNav()  // 单位性质
            this.getEducationNav()   // 最高学历
            this.getPosttitleNav()
        },
        methods: {
            // 预览
            handleNotesModal() {
                let params = this.formatFormParams()
                this.previewData = params
                this.seeModalShow = true
                this.$refs.seeModalRef.posttitle = this.dropTitle   // 报考岗位
                this.$refs.seeModalRef.positionname = this.droptionname   // 报考科室
                this.$refs.seeModalRef.departname = this.positionID   // 报考科室
            },

            // 处理form提交参数
            formatFormParams() {
                let params = {};
                params = {
                    ...this.ruleForm1,  // 基本信息
                    ...this.form2,    // 其他
                    ...this.form3,   // 附件
                    PlanID: this.mingeID,
                    OpenID: '',
                    PersonageTitle: '',  // 校内外任职
                    ResumeState: 0,
                    RecruitType: 0,   // 0 社招 1 校园招聘
                    OneselfPhotograph: this.ruleForm1.OneselfPhotograph,  // 个人证件照
                    StudyList: this.StudyList,   // 学习经历
                    WorkList: this.WorkList,   // 工作经历
                    Diploma: this.DiplomaList.map(item => item.url).join(),  // 毕业证
                    DegreeCertificate: this.DegreeCertificate.map(item => item.url).join(),  // 学位证
                    MemberFamilyList: this.MemberFamilyList,   // 家庭成员
                    Resume: this.fileResumeList.map(item => item.url).join(),   // 个人简历
                    GetJobRecommend: this.GetJobRecommend.map(item => item.url).join(),  // 就业推荐,学校成绩单,学生证
                    DiplomaAuthentica: this.DiplomaAuthentica.map(item => item.url).join(),   // 学历认证
                    DegreeCertificateAuthentica: this.DegreeCertificateAuthentica.map(item => item.url).join(),  // 学位认证
                    StudentCertification: this.StudentCertification.map(item => item.url).join(),  // 学籍认证报告
                    WorkProve: this.WorkProve.map(item => item.url).join(),   // 工作证明
                    QualificationCertificate: this.QualificationCertificate.map(item => item.url).join(),   // 资格证书
                    RestsCertificate: this.RestsCertificate.map(item => item.url).join(),   // 获奖证书及其他有关证书
                }
                return params
            },

            // 上一步
            handleTabActiveName(type) {
                if (type == 'first') {
                    this.completionRate = 0
                    this.tabActiveName = 'first'
                } else if (type == 'second') {
                    this.tabActiveName = 'second'
                    this.completionRate = 20
                } else if (type == 'third') {
                    this.tabActiveName = 'third'
                    this.completionRate = 36
                } else if (type == 'fourth') {
                    this.tabActiveName = 'fourth'
                    this.completionRate = 52
                } else if (type == 'fifth') {
                    this.tabActiveName = 'fifth'
                    this.completionRate = 68
                }
            },

            // 提交
            submitForm(type) {
                if (type == 1) {  // 基本信息
                    if (!this.deliveryID || !this.positionID || !this.mingeID) {
                        return this.$message.warning(`请完善招聘岗位选择`)
                    } else if (!this.ruleForm1.OneselfPhotograph) {
                        return this.$message.warning(`请上传证件照`)
                    }

                    let formName1 = "ruleForm1"
                    this.$refs[formName1].validate(valid => {
                        if (valid) {
                            this.tabActiveName = "second"
                            this.completionRate = 20
                        } else {
                            this.tabActiveName = "first"
                            this.$message.warning("请完善基本信息")
                            return false;
                        }
                    })
                } else if (type == 2) {   // 学习经历
                    // 学习经历必填
                    if (this.StudyList.length == 0) {
                        return this.$message.warning('请添加学习经历')
                    }

                    var that = this
                    let flag = that.StudyList.every(item => !!item.StudyStartDate && !!item.StudyEndDate && !!item.EducationID && !!item.GraduationSchool && !!item.EducationalSystem && !!item.Major && !!item.LearningStyleID)
                    if (!flag) {
                        return this.$message.error('学习经历有未填项请完善')
                    }
                    this.tabActiveName = "third"
                    this.completionRate = 36
                } else if (type == 3) {
                    var that = this
                    let flag = that.WorkList.every(item => !!item.WorkUnit && !!item.Post && !!item.WorkStartDate && !!item.WorkEndDate && !!item.ProfessionalTitle && !!item.WorkName)
                    if (!flag) {
                        return this.$message.error('工作经历有未填项请完善')
                    }

                    this.tabActiveName = "fourth"
                    this.completionRate = 52
                } else if (type == 4) {   // 其他
                    // 家庭成员必填
                    if (this.MemberFamilyList.length == 0) {
                        return this.$message.warning('请添加家庭成员')
                    }

                    var that = this
                    let flag = that.MemberFamilyList.every(item => !!item.UserName && !!item.Relationship && !!item.WorkUnit && !!item.Post && !!item.PlaceDomicile)
                    if (!flag) {
                        return this.$message.error('家庭成员有未填项请完善')
                    }

                    this.tabActiveName = "fifth"
                    this.completionRate = 68
                } else if (type == 5) {    // 其他
                    this.tabActiveName = "sixth"
                    this.completionRate = 84
                } else if (type == 6) {  // 预览
                    // 个人简历
                    if (this.fileResumeList.length == 0) {
                        return this.$message.warning('请完善附件信息')
                    } else if (!this.form3.IDCardFront) {  // 身份证正面
                        return this.$message.warning('请上传身份证正面')
                    } else if (!this.form3.IDCardRear) {   // 身份证反面
                        return this.$message.warning('请上传身份证反面')
                    }

                    let params = this.formatFormParams()
                    this.completionRate = 100
                    this.previewData = params
                    this.notesModalShow = true
                    this.$refs.socialModalRef.posttitle = this.dropTitle   // 报考岗位
                    this.$refs.socialModalRef.positionname = this.droptionname   // 报考科室
                    this.$refs.socialModalRef.departname = this.positionID   // 报考科室
                }
            },

            // 删除正面身份证
            iconSuffixDel() {
                this.fileNameIDCardFront = ""
                this.form3.IDCardFront = ''
            },

            // 删除反面身份证
            iconPrefixDel() {
                this.fileNameIDCardRear = ""
                this.form3.IDCardRear = ''
            },

            // 获取岗位下拉（微信）
            getPosttitleNav() {
                this.myFetch.get("/RecruitManagement/GetPostPullWX").then(res => {
                    this.posttitleNav = res.data.data
                }).catch(e => {
                    this.$message({
                        message: "网络或程序异常！" + e,
                        type: "error"
                    });
                });
            },

            // 招聘岗位
            changePosition(val) {
                let obj = {}
                obj = this.posttitleNav.find(item => {
                    return item.posttitle === val
                })

                this.dropTitle = obj.posttitle
                this.droptionname = obj.positionname
                this.getDepartListPullByPostWX(obj.posttitle, obj.positionname)
                this.getDepartNav = []  // 部门
                this.pullByDepartNav = []   // 学历
            },

            // 请选择科室/部门
            changePositionNav(val) {
                this.mingeName = val
                this.mingeID = ""   // 学历
                this.GetPullByDepartWX(this.dropTitle, this.droptionname, this.mingeName)
            },

            // 获取部门下拉
            getDepartListPullByPostWX(posttitle, positionname) {
                this.myFetch.get(`/RecruitManagement/GetDepartListPullByPostWX?PostTitle=${posttitle}&PositionName=${positionname}`).then(res => {
                    this.getDepartNav = res.data.data
                }).catch(e => {
                    this.$message({
                        message: "网络或程序异常！" + e,
                        type: "error"
                    });
                });
            },

            // 获取学历下拉
            GetPullByDepartWX(posttitle, positionname, mingeName) {
                this.myFetch.get(`/RecruitManagement/GetEducationNameListPullByDepartWX?PostTitle=${posttitle}&PositionName=${positionname}&DepartName=${mingeName}`).then(res => {
                    this.pullByDepartNav = res.data.data
                }).catch(e => {
                    this.$message({
                        message: "网络或程序异常！" + e,
                        type: "error"
                    });
                });
            },

            // 学习形式
            changeLearning(val) {
                let obj = {}
                obj = this.learningNav.find(item => {
                    return item.dict_code === val
                })
                if (val) {
                    this.ruleForm1.LearningStyleID = obj.dict_code
                    this.ruleForm1.LearningStyle = obj.dict_label
                } else {
                    this.ruleForm1.LearningStyleID = ""
                    this.ruleForm1.LearningStyle = ""
                }
            },

            // 学位
            changeDegree(val) {
                let obj = {}
                obj = this.degreeNav.find(item => {
                    return item.dict_code === val
                })
                if (val) {
                    this.ruleForm1.DegreeID = obj.dict_code
                    this.ruleForm1.Degree = obj.dict_label
                } else {
                    this.ruleForm1.DegreeID = ""
                    this.ruleForm1.Degree = ""
                }
            },

            // 请选择最高学历
            changeHighest(val) {
                let obj = {}
                obj = this.HighestNav.find(item => {
                    return item.dict_code === val
                })
                if (val) {
                    this.ruleForm1.HighestEducationID = obj.dict_code
                    this.ruleForm1.HighestEducation = obj.dict_label
                } else {
                    this.ruleForm1.HighestEducationID = ""
                    this.ruleForm1.HighestEducation = ""
                }
            },

            // 英语水平等级
            changeEnglish(val) {
                let obj = {}
                obj = this.englishNav.find(item => {
                    return item.dict_code === val
                })
                if (val) {
                    this.ruleForm1.EnglishLevelID = obj.dict_code
                    this.ruleForm1.EnglishLevel = obj.dict_label
                } else {
                    this.ruleForm1.EnglishLevelID = ""
                    this.ruleForm1.EnglishLevel = ""
                }
            },

            // 单位性质
            changeNatureUnit(val) {
                let obj = {}
                obj = this.NatureUnitNav.find(item => {
                    return item.dict_code === val
                })
                if (val) {
                    this.ruleForm1.NatureUnitID = obj.dict_code
                    this.ruleForm1.NatureUnit = obj.dict_label
                } else {
                    this.ruleForm1.NatureUnitID = ""
                    this.ruleForm1.NatureUnit = ""
                }
            },

            // 上传个人简历
            async uploadFile(param) {
                const fileObj = new FormData();
                fileObj.append("files", param.file);
                this.myFetch.post("/RecruitTalentPool/WXUploadAttachFile?channeltype=6", fileObj).then(res => {
                    this.fileResumeList.push(
                        {
                            name: res.data.data[0].originalfilename,
                            url: res.data.data[0].filename
                        }
                    )
                }).catch(e => {
                    this.$message({
                        message: "网络或程序异常！" + e,
                        type: "error"
                    });
                });
            },

            /** 删除上传个人简历 */
            handleFileRemove(file, fileList) {
                this.fileResumeList = fileList
            },

            // 毕业证
            async diplomaProveUploadFile(param) {
                const fileObj = new FormData();
                fileObj.append("files", param.file);
                this.myFetch.post("/RecruitTalentPool/WXUploadAttachFile?channeltype=6", fileObj).then(res => {
                    this.DiplomaList.push(
                        {
                            name: res.data.data[0].originalfilename,
                            url: res.data.data[0].filename
                        }
                    )
                }).catch(e => {
                    this.$message({
                        message: "网络或程序异常！" + e,
                        type: "error"
                    });
                });
            },

            // 删除毕业证
            diplomaProveUploadFileRemove(file, fileList) {
                this.DiplomaList = fileList
            },

            // 学位证明
            async educationDegreeProveUploadFile(param) {
                const fileObj = new FormData();
                fileObj.append("files", param.file);
                this.myFetch.post("/RecruitTalentPool/WXUploadAttachFile?channeltype=6", fileObj).then(res => {
                    this.DegreeCertificate.push(
                        {
                            name: res.data.data[0].originalfilename,
                            url: res.data.data[0].filename
                        }
                    )
                }).catch(e => {
                    this.$message({
                        message: "网络或程序异常！" + e,
                        type: "error"
                    });
                });
            },

            // 删除学位证明
            fileDegreFileRemove(file, fileList) {
                this.DegreeCertificate = fileList
            },

            // 毕业认证
            async DiplomaAuthenticaUploadFile(param) {
                const fileObj = new FormData();
                fileObj.append("files", param.file);
                this.myFetch.post("/RecruitTalentPool/WXUploadAttachFile?channeltype=6", fileObj).then(res => {
                    this.DiplomaAuthentica.push(
                        {
                            name: res.data.data[0].originalfilename,
                            url: res.data.data[0].filename
                        }
                    )
                }).catch(e => {
                    this.$message({
                        message: "网络或程序异常！" + e,
                        type: "error"
                    })
                })
            },

            // 删除毕业认证
            DiplomaAuthenticaFileRemove(file, fileList) {
                this.DiplomaAuthentica = fileList
            },

            // 学位证明
            async DegreeCertificationUploadFile(param) {
                const fileObj = new FormData();
                fileObj.append("files", param.file);
                this.myFetch.post("/RecruitTalentPool/WXUploadAttachFile?channeltype=6", fileObj).then(res => {
                    this.DegreeCertificateAuthentica.push(
                        {
                            name: res.data.data[0].originalfilename,
                            url: res.data.data[0].filename
                        }
                    )
                }).catch(e => {
                    this.$message({
                        message: "网络或程序异常！" + e,
                        type: "error"
                    });
                });
            },

            // 删除学位证明
            DegreeCertificationFileRemove(file, fileList) {
                this.DegreeCertificateAuthentica = fileList
            },

            // 学籍认证报告
            async studentStatusProveUploadFile(param) {
                const fileObj = new FormData();
                fileObj.append("files", param.file);
                this.myFetch.post("/RecruitTalentPool/WXUploadAttachFile?channeltype=6", fileObj).then(res => {
                    this.StudentCertification.push(
                        {
                            name: res.data.data[0].originalfilename,
                            url: res.data.data[0].filename
                        }
                    )
                }).catch(e => {
                    this.$message({
                        message: "网络或程序异常！" + e,
                        type: "error"
                    });
                });
            },

            // 删除学籍认证报告
            studentStatusProveFileRemove(file, fileList) {
                this.StudentCertification = fileList
            },

            // 就业推荐表、学校成绩单、学生证等其他相关证明材料
            async otherRelevantProveUploadFile(param) {
                const fileObj = new FormData();
                fileObj.append("files", param.file);
                this.myFetch.post("/RecruitTalentPool/WXUploadAttachFile?channeltype=6", fileObj).then(res => {
                    this.GetJobRecommend.push(
                        {
                            name: res.data.data[0].originalfilename,
                            url: res.data.data[0].filename
                        }
                    )
                }).catch(e => {
                    this.$message({
                        message: "网络或程序异常！" + e,
                        type: "error"
                    });
                });
            },

            // 删除就业推荐表、学校成绩单、学生证等其他相关证明材料
            otherRelevantProveFileRemove(file, fileList) {
                this.GetJobRecommend = fileList
            },

            // 工作证明
            async WorkProveUploadFile(param) {
                const fileObj = new FormData();
                fileObj.append("files", param.file);
                this.myFetch.post("/RecruitTalentPool/WXUploadAttachFile?channeltype=6", fileObj).then(res => {
                    this.WorkProve.push(
                        {
                            name: res.data.data[0].originalfilename,
                            url: res.data.data[0].filename
                        }
                    )
                }).catch(e => {
                    this.$message({
                        message: "网络或程序异常！" + e,
                        type: "error"
                    });
                });
            },

            // 删除工作证明
            WorkProveFileRemove(file, fileList) {
                this.WorkProve = fileList
            },

            // 资格证书
            async QualificationCertificateUploadFile(param) {
                const fileObj = new FormData();
                fileObj.append("files", param.file);
                this.myFetch.post("/RecruitTalentPool/WXUploadAttachFile?channeltype=6", fileObj).then(res => {
                    this.QualificationCertificate.push(
                        {
                            name: res.data.data[0].originalfilename,
                            url: res.data.data[0].filename
                        }
                    )
                }).catch(e => {
                    this.$message({
                        message: "网络或程序异常！" + e,
                        type: "error"
                    });
                });
            },

            // 删除资格证书
            QualificationCertificateFileRemove(file, fileList) {
                this.QualificationCertificate = fileList
            },

            // 其他有关证书
            async RestsCertificateUploadFile(param) {
                const fileObj = new FormData();
                fileObj.append("files", param.file);
                this.myFetch.post("/RecruitTalentPool/WXUploadAttachFile?channeltype=6", fileObj).then(res => {
                    this.RestsCertificate.push(
                        {
                            name: res.data.data[0].originalfilename,
                            url: res.data.data[0].filename
                        }
                    )
                }).catch(e => {
                    this.$message({
                        message: "网络或程序异常！" + e,
                        type: "error"
                    });
                });
            },

            // 删除其他有关证书
            fileRestscertificateListRemove(file, fileList) {
                this.RestsCertificate = fileList
            },

            // 上传身份证正面
            async uploadJust(param) {
                const fileObj = new FormData();
                fileObj.append("files", param.file);
                this.myFetch.post("/RecruitTalentPool/WXUploadAttachFile?channeltype=6", fileObj).then(res => {
                    this.fileNameIDCardFront = res.data.data[0].originalfilename
                    this.form3.IDCardFront = res.data.data[0].filename
                }).catch(e => {
                    this.$message({
                        message: "网络或程序异常！" + e,
                        type: "error"
                    });
                });
            },

            // 上传身份证反面
            async uploadBack(param) {
                const fileObj = new FormData();
                fileObj.append("files", param.file);
                this.myFetch.post("/RecruitTalentPool/WXUploadAttachFile?channeltype=6", fileObj).then(res => {
                    this.fileNameIDCardRear = res.data.data[0].originalfilename
                    this.form3.IDCardRear = res.data.data[0].filename
                }).catch(e => {
                    this.$message({
                        message: "网络或程序异常！" + e,
                        type: "error"
                    });
                });
            },

            // 获取最高学历
            getHighestNav() {
                this.baseFetch.post("/SysDictData/GetList", {dict_type: 'education'}).then(res => {
                    this.HighestNav = res.data.data
                }).catch(e => {
                    this.$message({
                        message: "网络或程序异常！" + e,
                        type: "error"
                    });
                });
            },

            // 最高学历
            getEducationNav() {
                this.baseFetch.post("/SysDictData/GetList", {dict_type: 'recruit_education'}).then(res => {
                    this.EducationNav = res.data.data
                }).catch(e => {
                    this.$message({
                        message: "网络或程序异常！" + e,
                        type: "error"
                    });
                });
            },

            // 政治面貌
            getPoliticsNav() {
                this.baseFetch.post("/SysDictData/GetList", {dict_type: 'political_outlook'}).then(res => {
                    this.politicsNav = res.data.data
                }).catch(e => {
                    this.$message({
                        message: "网络或程序异常！" + e,
                        type: "error"
                    });
                });
            },

            // 单位性质
            getNatureUnitNav() {
                this.baseFetch.post("/SysDictData/GetList", {dict_type: 'Unit_Properties'}).then(res => {
                    this.NatureUnitNav = res.data.data
                }).catch(e => {
                    this.$message({
                        message: "网络或程序异常！" + e,
                        type: "error"
                    });
                });
            },

            // 英语水平等级
            getEnglishNav() {
                this.baseFetch.post("/SysDictData/GetList", {dict_type: 'sys_english_level'}).then(res => {
                    this.englishNav = res.data.data
                }).catch(e => {
                    this.$message({
                        message: "网络或程序异常！" + e,
                        type: "error"
                    });
                });
            },

            // 学位
            getDegreeNav() {
                this.baseFetch.post("/SysDictData/GetList", {dict_type: 'academic_degree'}).then(res => {
                    this.degreeNav = res.data.data
                }).catch(e => {
                    this.$message({
                        message: "网络或程序异常！" + e,
                        type: "error"
                    })
                })
            },

            // 学习形式
            getLearningNav() {
                this.baseFetch.post("/SysDictData/GetList", {dict_type: 'Learning_form'}).then(res => {
                    this.learningNav = res.data.data
                }).catch(e => {
                    this.$message({
                        message: "网络或程序异常！" + e,
                        type: "error"
                    });
                });
            },

            // 上传证件照
            uploadOneselfPhotograph({file}) {
                const fileObj = new FormData();
                fileObj.append("files", file);
                this.myFetch.post("/RecruitTalentPool/WXUploadAttachFile?channeltype=6", fileObj).then(res => {
                    this.ruleForm1.OneselfPhotograph = res.data.data[0].filename
                }).catch(e => {
                    this.$message({
                        message: "网络或程序异常！" + e,
                        type: "error"
                    });
                });
            },

            // 清空证件照
            photographDel() {
                this.ruleForm1.OneselfPhotograph = ''
            },

            //  学习经历增加行
            addLineEducational() {
                var newValue = {
                    StudyStartDate: '',   // 学习开始时间
                    StudyEndDate: '',     // 学习结束时间
                    EducationID: '',      // 学历ID
                    GraduationSchool: '',   // 毕业学校
                    EducationalSystem: '',    // 学制
                    Major: '',    // 所学专业
                    LearningStyleID: '',   // 学习形式ID
                }
                this.StudyList.push(newValue)
            },

            // 工作经历增加行
            addLineWork() {
                var newValue = {
                    WorkUnit: '',    // 工作单位
                    Post: '',   // 职务
                    WorkStartDate: '',   // 工作开始日期
                    WorkEndDate: '',    // 工作结束日期
                    ProfessionalTitle: '',   // 职称
                    WorkName: ''    // 主要从事工作
                }

                this.WorkList.push(newValue)
            },

            // 家庭成员
            addLineFamily() {
                var newValue = {
                    UserName: '',   // 姓名
                    Relationship: '',   // 与本人关系
                    WorkUnit: '',    // 工作单位
                    Post: '',    // 职称
                    PlaceDomicile: '',   // 户籍所在地
                }
                this.MemberFamilyList.push(newValue)
            },

            // 学习经历增加行
            handleDelete(index) {
                this.StudyList.splice(index, 1)
            },

            // 工作经历删除
            handleDelLineWork(index) {
                this.WorkList.splice(index, 1)
            },

            // 家庭成员删除
            handleDelLineFamily(index) {
                this.MemberFamilyList.splice(index, 1)
            },

            // 文件类型图片跟pdf判断
            checkFileType(file) {
                const fileType = file.type;
                const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'];
                if (!allowedTypes.includes(fileType)) {
                    this.$message.error('只能上传图片跟pdf文件');
                    return false;
                }
                return true;
            },

            // 只能上传图片
            checkFileTypeImage(file) {
                const fileType = file.type;
                const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png'];
                if (!allowedTypes.includes(fileType)) {
                    this.$message.error('只能上传图片');
                    return false;
                }
                return true;
            },

            // 过滤身高值
            validateHeight(val) {
                // 正则表达式匹配厘米为单位的身高值
                const regex = /^\d{1,3}(cm)?$/
                if (!regex.test(val)) {
                    // 如果输入无效，则删除非数字字符和“cm”后缀
                    this.ruleForm1.Height = this.ruleForm1.Height.replace(/[^\d]/g, '')
                    if (this.ruleForm1.Height) {
                        this.ruleForm1.Height += 'cm'
                    }
                }
            }
        },
        watch: {
            deliveryID(e) {
                this.positionID = ""
                this.mingeID = ""
            },
        }
    }
</script>

<style scoped lang="scss">
    @import "index";
</style>
